import '/assets/styles/sections/branch-info.scss';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useTranslation } from '/utilities/i18n';

// Sections
import PageHeader from '/views/sections/page-header';

const BranchInfo = () => {
	const { initialized, selectedBranch, tableNumber } = useBranchSelection();
	const { t } = useTranslation();

	if (!selectedBranch && initialized) {
		return null;
	}

	return (
		<PageHeader
			className="branch-info"
			icon="menu"
			backLinkRedirect
			backLinkText={t('Değiştir')}
			backLinkIcon="return"
			backLink="placeOrder"
			title={selectedBranch?.title ?? false}
			subtitle={
				!initialized ? false : selectedBranch && tableNumber ? `Masa ${tableNumber}` : undefined
			}
		/>
	);
};

export default BranchInfo;
